import request from "@/utils/request"
const platform = localStorage.getItem('platform')

export function getTeams(data) {
    return request.get(`/${platform}/teams`,data)
}

export function storeOrUpdateTeam(data) {
    const method = data.id ? 'put' : 'post'
    const url = data.id ? `/${platform}/teams/${data.id}` : `/${platform}/teams`;
    return request[method](url, data)
}
